import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import moment from "dayjs";
import { connect } from "react-redux";
import coordtransform from "../utils/coordtransform";
const { threeDUrl } = window.globalConfig;

// import { setMapFullScreen } from "../../store/actions/common";
/**
 * ======== UI组件
 */

/**
 * ======== 图片引用
 */

import center_map_shuichang from "../assets/center_map_shuichang.png";
import center_map_shuichang_off from "../assets/center_map_shuichang_off.png";
import center_map_position from "../assets/center_map_position.png";

/**
 * ====== redux
 */
import { setScreenInfo } from "@store/actions/common";

/**
 * ======== api
 */
import API from "../api/screen";

import "./Amap.scss";
import { is } from "immutable";

const styles = {
  color: "rgba(255, 255, 255, 0.85)",
  padding: "0 6px",
  fontSize: "12px",
  height: "24px",
  lineHeight: "24px",
  background: "#1E2D52",
  borderRadius: "13px",
  fontFamily: "微软雅黑",
  border: "1px solid rgba(49, 213, 223, 0.85)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  textAlign: "center",
  transform: "translateX(-50%)",
};

const ModalStyle = {
  // position: "absolute",
  // zIndex: 120,
  background: "rgba(21, 81, 94, 0.8)",
  backdropFilter: "blur(10px)",
  boxShadow: "0px 3px 3px 1px rgba(0, 0, 0, 0.25)",
};

const returnTxt = (text, unit, isNumber = true) => {
  return text !== null && text !== undefined ? (
    <span className="font12">
      <span className={isNumber && "blueColor"}>{`${text} `}</span>
      {`${unit || ""}`}
    </span>
  ) : (
    <span className="font12">-</span>
  );
};

const Block = ({ label, value, unit, isNumber = true }) => {
  return (
    <div className="window-info-list">
      <span className="font12">{label}：</span>
      <span className="font16">{returnTxt(value, unit, isNumber)}</span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    Common: { ...state.Common },
  };
};

class Map extends React.Component {
  timer = null;

  constructor(props) {
    super(props);
    this.state = {
      map: null,
      loading: false,
      polylineOverlayGroup: null,
      infoWindow: null,
      zoom: 11,
      info: {},
      show: false,
      stationInfo: [], //站点数据  warning=true 告警 false=正常， data是详细告警数据
      interval: null, //轮询站点
      active: 0, //当前站点
      interval_all: null, //轮询站点列表
    };
  }

  componentDidMount() {
    // const { zoom, infoWindow, list } = this.state;
    // let map = new AMap.Map("map_Amap", {
    //   zoom,
    //   center: [104.633902, 31.50306],
    // });
    // this.setState(
    //   {
    //     map,
    //   },
    //   () => {
    //     let { map } = this.state;
    //     // map.enableScrollWheelZoom(true);
    //     map.setMapStyle("amap://styles/581080db4c5cc0568d0a93469f3733db");
    //     // this.addPerson();

    //     this.getSelectGisStationList();

    //     map.on("click", () => {
    //       if (infoWindow) {
    //         infoWindow.close();
    //       }
    //     });
    //   }
    // );
    this.getSelectGisStationList();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      //隐藏之前的marker，显示新的marker
      this.change(nextProps.active, nextProps.activeText);
    }
    // 点击了监控关闭，继续轮询
    if (
      this.props.Common.screenInfo.clickStationId !==
        nextProps.Common.screenInfo.clickStationId &&
      !nextProps.Common.screenInfo.clickStationId
    ) {
      this.setInterval_station();
    }
    //选中了站点，停止轮询
    if (
      this.props.Common.screenInfo.clickStationId !==
        nextProps.Common.screenInfo.clickStationId &&
      nextProps.Common.screenInfo.clickStationId
    ) {
      clearInterval(this.state.interval);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  componentWillUnmount() {
    clearInterval(this.state.interval);
    clearInterval(this.state.interval_all);
  }

  change = (active, activeText) => {
    // this.showOverlays({ type: "waterPlant_content" }, false);
    this.selectGisStationWaterQuality(active, activeText);
  };

  //获取站点列表
  getSelectGisStationList = () => {
    API.selectGisStationList().then((res) => {
      if (res.status == 0) {
        this.setState({ stationInfo: res.data.stationInfo });
        const inLine = res.data.stationInfo.filter(
          (item) => item.stationStatus == 1
        ).length;
        const offLine = res.data.stationInfo.filter(
          (item) => item.stationStatus == 2
        ).length;
        this.props.dispatch(
          setScreenInfo({
            ...this.props.Common.screenInfo,
            stationList: res.data.stationInfo,
            alarmAndStationOnLineNum: res.data.alarmAndStationOnLineNum,
            stationStatistics: { inLine, offLine },
            stationId: res.data.stationInfo[0]?.id,
            stationName: res.data.stationInfo[0]?.name,
            activeStation: 0,
          })
        );
        // this.showOverlays({ type: "waterPlant" }, false);
        this.addMultiMaker(
          res.data.stationInfo,
          "waterPlant",
          new AMap.Pixel(0, 0)
        );
        if (!this.state.interval_all) {
          this.selectGisStationWaterQuality();
          this.setInterval_station();
          const interval_all = setInterval(() => {
            this.getSelectGisStationList();
          }, 2 * 60 * 1000);
          this.setState({ interval_all });
        }
      }
    });
  };

  //站点轮询
  setInterval_station = () => {
    let interval = "";
    const { stationInfo } = this.state;
    interval = setInterval(() => {
      const { active } = this.state;
      if (active < stationInfo.length - 1) {
        this.setState({ active: this.state.active + 1 });
        this.props.dispatch(
          setScreenInfo({
            ...this.props.Common.screenInfo,
            stationId: stationInfo[active + 1]?.id,
            stationName: stationInfo[active + 1]?.name,
          })
        );
      } else {
        this.setState({ active: 0 });
        this.props.dispatch(
          setScreenInfo({
            ...this.props.Common.screenInfo,
            stationId: stationInfo[0]?.id,
            stationName: stationInfo[0]?.name,
          })
        );
      }
    }, 30 * 60 * 1000);
    this.setState({ interval });
  };

  //水质数据
  selectGisStationWaterQuality = (
    active = this.props.active,
    activeText = this.props.activeText
  ) => {
    API.selectGisStationWaterQuality({ gisWaterQualityType: active }).then(
      (res) => {
        if (res.status == 0) {
          const { stationInfo } = this.state;
          const _stationInfo = JSON.parse(JSON.stringify(stationInfo));
          _stationInfo.map((item) => {
            if (res.data[item.name]) {
              if (active == 0 || active == 6) {
                //故障告警或者设备告警
                item.detailData = res.data[item.name];
                item.warning = true;
                item.active = active;
              } else {
                const d = res.data[item.name][0] || {};
                // item = { ...item, ...d, label: activeText, value: d.parValue, detailData: [] }
                item.label = activeText;
                item.value =
                  d.parValue === null ? "--" : (d.parValue * 1).toFixed(3);
                item.detailData = [];
                item.alarmInfo = d.alarmInfo;
                item.unit = d.parUnit;
                item.active = active;
              }
            } else {
              item.active = active;
              if (active != 0 && active != 6) {
                item.label = activeText;
              }
              item.value = "--";
              item.detailData = [];
            }
          });
          // this.setState({ stationInfo: _stationInfo })
          this.addMultiMaker(
            _stationInfo,
            "waterPlant_content",
            new AMap.Pixel(0, -45)
          );
        }
      }
    );
  };

  sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  /**
   * @description 隐藏显示 标记 线 面
   * @param {*} data  包含 type
   * @param {*} isShow 显示、隐藏
   */

  showOverlays = async (data, isShow) => {
    const { type } = data;
    let { map } = this.state;
    this.setState({ loading: true });

    this.setState({ loading: true }, () => {
      let overlays = map.getAllOverlays("marker");
      overlays = overlays.filter((item) => {
        const marker_type = item.getExtData().type;
        if (marker_type == type) {
          return item;
        }
      });
      // console.log(111, overlays);
      if (isShow) {
        overlays && overlays.show?.();
      } else {
        overlays && overlays.hide?.();
      }
      const _this = this;
      this.setOverlay(overlays, isShow).then(async (res) => {
        await this.sleep(0);
        _this.setState({ loading: false });
      });
    });
  };

  setOverlay = (overlays, isShow) => {
    let { infoWindow } = this.state;
    return new Promise((resolve, reject) => {
      if (overlays.length == 0) {
        resolve(true);
      }
      overlays.forEach((item, index) => {
        if (isShow) {
          item && item.show?.();
        } else {
          item && item.hide?.();
          if (infoWindow) {
            infoWindow.close();
          }
        }
        if (index === overlays.length - 1) {
          resolve(true);
        }
      });
    });
  };

  /**
   *  获取区域的中心点
   * @param {*} lnglatarr
   * @returns
   */
  getAreaCenter = function (points) {
    let x = 0,
      y = 0,
      i,
      min = 0,
      j,
      f,
      point1,
      point2;
    const max = points.length;
    let area = function () {
      let area = 0,
        point2;

      for (let i = 0, j = max - 1; i < max; j = i, i++) {
        point1 = points[i];
        point2 = points[j];
        area += point1.lng * point2.lat;
        area -= point1.lat * point2.lng;
      }
      area /= 2;

      return area;
    };
    for (let i = 0, j = max - 1; i < max; j = i, i++) {
      point1 = points[i];
      point2 = points[j];
      f = point1.lng * point2.lat - point2.lng * point1.lat;
      x += (point1.lng + point2.lng) * f;
      y += (point1.lat + point2.lat) * f;
    }

    f = area() * 6;
    let xSum = x / f,
      ySum = y / f;

    return new AMap.LngLat(xSum, ySum);
  };

  /**
   * @description 添加 人定位
   */
  addPerson = () => {
    let data = [
      { lon: 105.52, lat: 29.20356, label: "", value: "李富贵", type: 0 },
      { lon: 105.43, lat: 29.09011, label: "", value: "小明", type: 1 },
    ];
    this.addMultiMaker(data, "person");
  };

  /**
   * @description 添加多个标注点
   * @param {*} type
   * @param {*} icon
   * @param {*} data
   */
  addMultiMaker = (data = [], type, offset) => {
    data.map((item) => {
      this.addMaker(item, type, offset);
    });
  };

  /**
   * @description 设置显示的内容
   * @param {*} data
   * @param {*} type  person waterPlant waterPlant_content
   * @param {*} value_class
   * @param {*} showLabel
   * @returns
   */
  setMarkerContent = (data, type, value_class, showLabel = true) => {
    const renderRow = (info) => {
      return (
        "<div key={'" +
        data.value +
        "'} class='marker_row'><span class='marker_row_label'>" +
        info.label +
        "</span>" +
        "<span class='marker_row_value'>" +
        info.value +
        "</span> </div>"
      );
    };
    let content = "";
    switch (type) {
      case "person":
        content =
          "<div class='map_waterPlant flexColumn alignItemCenter'>" +
          "<span class='marker_value postion_value'>" +
          data.value +
          "</span>" +
          "<img src='" +
          center_map_position +
          "' class='position_icon'/>" +
          "</div>";
        break;
      case "waterPlant":
        content = "<div class='map_waterPlant flexColumn alignItemCenter'>";
        if (data.stationStatus == 1) {
          //在线
          content +=
            "<img src='" + center_map_shuichang + "' class='waterPlant_icon'/>";
        } else {
          //离线
          content +=
            "<img src='" +
            center_map_shuichang_off +
            "' class='waterPlant_icon'/>";
        }
        content +=
          "<div class='waterPlant_label' id='waterPlant_" +
            data.name +
            "'>" +
            data.aliasName || data.name + "</div>" + "</div>";
        break;
      case "waterPlant_content":
        content = "<div class='map_waterPlant flexColumn alignItemCenter'>";
        if (data.active == 0 || data.active == 6) {
          //故障告警或设备告警
          if (data.detailData && data.detailData.length) {
            content += "<div class='marker_value warning_value'>";
            if (data.active == 0) {
              //故障告警
              content += renderRow({
                label: "故障告警",
                value: data.detailData.length,
              });
            } else {
              //设备告警
              content += renderRow({
                label: "设备告警",
                value: data.detailData.length,
              });
            }
            content += "</div>";
          }
          content += "</div>";
        } else {
          console.log(data.value);
          let isShow = data.value != "--";
          if (isShow) {
            content += "<div class='marker_value waterPlant_value'>";
            content += renderRow(
              isShow
                ? { label: data.label, value: data.value }
                : { label: "", value: "" }
            );
            content += "</div>";
          }
        }
        break;
    }
    // let content =
    //   "<div class='map_waterPlant flexColumn alignItemCenter'>"
    // if (data.active == 0 || data.active == 6) { //故障告警或设备告警
    //   if (data.detailData && data.detailData.length) {
    //     content += "<div class='marker_value " + value_class + "'>";
    //     if (data.active == 0) {//故障告警
    //       content += renderRow({ label: '故障告警', value: data.detailData.length });
    //     } else {//设备告警
    //       content += renderRow({ label: '设备告警', value: data.detailData.length });
    //     }
    //     content += '</div>'
    //   }
    // } else {
    //   content += "<div class='marker_value " + value_class + "'>";
    //   content += renderRow({ label: data.label, value: data.value });
    //   content += '</div>'
    // }

    // if (showLabel) {
    //   if (data.stationStatus == 0) { //在线
    //     content +=
    //       "<img src='" + center_map_shuichang + "' class='waterPlant_icon'/>"
    //   } else {//离线
    //     content +=
    //       "<img src='" + center_map_shuichang_off + "' class='waterPlant_icon'/>"
    //   }
    //   content +=
    //     "<div class='waterPlant_label' id='waterPlant_" + data.name + "'>" + data.name + '</div>'
    //     + "</div>"
    // } else {
    //   content +=
    //     "<img src='" + center_map_position + "' class='position_icon'/>"
    //     + "</div>"
    // }
    return content;
  };

  /**
   * @description 添加标注点
   * @param {*} data 数据
   * @param {*} type 类型： 水厂 人 最上面显示得数据
   * @param {*} type 偏移量
   */
  addMaker = (data, type, offset) => {
    let { map } = this.state;

    if (data.lon && data.lat) {
      let position = [];
      // const p = coordtransform.wgs84togcj02(coordinates[0], coordinates[1]);
      position = new AMap.LngLat(data.lon, data.lat);
      let m = {
        position: position,
        anchor: "bottom-center",
        extData: {
          type: type,
        },
      };
      if (offset) {
        m.offset = offset;
      }
      // if (data.warning) { //告警
      //   m.content = this.setMarkerContent(data, type, 'warning_value',);
      // } else if (type == 'person') {
      //   m.content = this.setMarkerContent(data, type, 'postion_value', false);
      // } else {
      //   m.content = this.setMarkerContent(data, type, 'waterPlant_value');
      // }
      m.content = this.setMarkerContent(data, type);
      if (!m.content) {
        return;
      }
      let makers = new AMap.Marker(m);
      makers.on("mouseover", (event) => {
        const position = makers.getPosition();
        if (data.detailData && data.detailData.length) {
          //告警-有详细数据
          this.showInfoWindow(data, position, data.detailData);
        }
      });
      makers.on("mouseout", (event) => {
        const { infoWindow } = this.state;
        if (data.detailData && data.detailData.length) {
          //告警
          if (infoWindow) {
            infoWindow.close();
          }
        }
      });
      makers.on("click", (event) => {
        // 点击电站
        //切换是否开启轮询
        if (type === "waterPlant") {
          clearInterval(this.state.interval);
          this.props.dispatch(
            setScreenInfo({
              ...this.props.Common.screenInfo,
              stationId: data.id,
              stationName: data.name,
              clickStationId: data.id,
            })
          );
        }
      });

      map && map.add(makers);
    }
  };

  /**
   *
   * @param {*} data
   */

  renderInfo = (data) => {
    let returnText = "";
    const renderText = (text, unit = "", isNumber = true) => {
      return text !== null && text !== undefined
        ? "<span class='font12'><span class='" +
            (isNumber ? "blueColor mr4" : "mr4") +
            "'>" +
            text +
            "</span>" +
            unit +
            "</span>"
        : "<span class='font12'>-</span>";
    };

    const renderRow = (data, i) => {
      const { label, value, unit, isNumber } = data;
      return (
        `<div key='dd${i}'  class='window-info-list'> ` +
        "<span class='font12'>" +
        label +
        "：</span>" +
        "<span class=''>" +
        renderText(value, unit, isNumber) +
        "</span >" +
        "</div > "
      );
    };

    data.map((item, i) => {
      returnText += renderRow(item, i);
    });
    return returnText;
  };

  closeWindow = () => {
    const { infoWindow } = this.state;
    infoWindow.close();
  };

  /**
   * @description 展示信息窗口
   */
  showInfoWindow = (info, position, data = []) => {
    const { map } = this.state;

    let infoData = [];
    const info_w = "<div class='info-window'>";
    infoData.push(info_w);
    infoData.push("<div class='window-info'>");
    infoData.push("<div class='info-title'>");
    infoData.push(info.active == 0 ? "故障告警" : "设备告警");
    infoData.push("</div>");
    infoData.push("<div class='info-wrapper'>");
    infoData.push(this.renderWarningData(data));
    infoData.push("</div></div>");

    // 创建 infoWindow 实例
    var infoWindow = new AMap.InfoWindow({
      // isCustom: true,  //使用自定义窗体
      content: infoData.join(""), //传入 dom 对象，或者 html 字符串
      anchor: "bottom-center",
    });
    infoWindow.open(map, position);
    this.setState({ infoWindow }, () => {
      const close_img = document.getElementById("close_img");
      close_img && close_img.addEventListener("click", this.closeWindow);
    });
  };

  renderWarningData = (data, i) => {
    let returnText = '<table class="table">';
    let renderRow = (info) => {
      return (
        "<tr key='dt" +
        i +
        "' class='warning_row'><td>" +
        info.createTime +
        "</td>" +
        "<td>" +
        info.alarmInfo +
        "</td> </tr>"
      );
    };
    // if (type == 'view') {
    //   renderRow = (info) => {
    //     return "<tr class='warning_row'><td>" + info.time + "</td>"
    //       + "<td>" + info.value + "</td>"
    //       + "<td>" + info.type + "</td> </tr>"
    //   }
    // }
    data.map((item, i) => {
      returnText += renderRow(item, i);
    });
    returnText += "</table>";
    return returnText;
  };

  returnTxt = (text = "", unit, isNumber = true) => {
    return text !== null && text !== undefined ? (
      <span className="font12">
        <span className={isNumber && "blueColor"}>{`${text} `}</span>
        {`${unit || ""}`}
      </span>
    ) : (
      "-"
    );
  };

  render() {
    let { loading } = this.state;
    return [
      <div id="map_Amap" className="AMap" key="_Bmap">
        <iframe
          style={{ display: "block", width: "100%", height: "100%", border: 0 }}
          src={threeDUrl}
        ></iframe>
      </div>,
      <Spin
        spinning={loading}
        tip="正在加载数据..."
        wrapperClassName="map_loading"
      ></Spin>,
    ];
  }
}

export default connect(mapStateToProps)(Map);
